<template>
  <div class="display-flex">
    <PrismEditor
      v-model="body"
      ref="prismEditor"
      :name="name"
      :highlight="highlighter"
      :class="customClass"
      :line-mumbers="false"
    />
    <template v-if="hasMacros">
      <button
        :id="tokenButtonRef"
        :ref="tokenButtonRef"
        v-t="'TOKEN'"
        class="btn btn-secondary flex--align-self-start"
        type="button"
        @click="toggleMacrosPopover"
      />
      <popover
        v-model="showMacrosPopover"
        custom-class="breakdown-legend__popover"
        placement="bottom"
        trigger="manual"
        :target="'#' + tokenButtonRef"
        @show="tagsPopoverVisible = true"
        @hide="tagsPopoverVisible = false"
      >
        <template slot="popover">
          <MacroSelectionPopover
            :focus-dropdown="tagsPopoverVisible"
            :trigger-element="$refs[tokenButtonRef]"
            :macros="macros"
            @blur="showMacrosPopover = false"
            @selected-tag="onSelectedTag"
          />
        </template>
      </popover>
    </template>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { GET_MACROS } from '@/modules/info/store/actionTypes';
import MacroSelectionPopover from '@/core/components/MacroSelectionPopover';
import { uniqueId } from 'lodash';

// import Prism Editor
import { PrismEditor } from 'vue-prism-editor';

// import highlighting library (you can use any library you want just return html string)
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-json';
import 'prismjs/components/prism-markup';

export default {
  components: { PrismEditor, MacroSelectionPopover },
  props: {
    name: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: null
    },
    bodyType: {
      type: String,
      default: null
    },
    customClass: {
      type: String,
      default: ''
    },
    hasMacros: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('info', ['macros']),
    body: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  data() {
    return {
      tagsPopoverVisible: false,
      showMacrosPopover: false,
      tokenButtonRef: this.generateRandomRefForToken(),
    };
  },
  async mounted() {
    await this.getMacros();
  },
  methods: {
    ...mapActions('info', { 'getMacros': GET_MACROS }),
    toggleMacrosPopover() {
      this.showMacrosPopover = !this.showMacrosPopover;
      return;
    },
    onSelectedTag(tag) {
      const textarea = this.$refs.prismEditor.$el.querySelector('.prism-editor__textarea');
      const cursorPosition = textarea.selectionStart;
      this.showMacrosPopover = false;
      const tagToAdd = tag.originalTag.macro;
      
      this.body = this.body ? this.body.substring(0, cursorPosition) + tagToAdd + this.body.substring(cursorPosition) : tagToAdd;
      this.$nextTick(() => {
        textarea.focus();
        textarea.selectionStart = cursorPosition + tagToAdd.length;
        textarea.selectionEnd = cursorPosition + tagToAdd.length;
      });
    },
    highlighter(code) {
      if (this.bodyType && this.bodyType == 'application/xml') {
        return highlight(code, languages.markup, 'xml');
      }
      return highlight(code, languages.json, 'json');
    },
    generateRandomRefForToken() {
      return uniqueId('tokenButtonRef')
    }
  }
};
</script>

<style>

</style>